import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const FooterBar = styled.div`
  height: 56px;
  background: ${vimovaTheme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  border: none;
  margin-bottom: 0;
  padding-bottom: 0;

  @media print {
    height: 56px !important;
    background: ${vimovaTheme.colors.primary} !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    padding: 0 32px !important;
    border: none !important;
    margin-bottom: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const FooterText = styled.span`
  color: rgba(255, 255, 255, 0.7);
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  border: none;

  @media print {
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 8px !important;
    border: none !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const FooterPageNumber = styled.span`
  color: rgba(255, 255, 255, 0.4);
  font-family: ${vimovaTheme.fonts.body};
  font-size: 9px;
  text-align: center;
  border: none;

  @media print {
    color: rgba(255, 255, 255, 0.4) !important;
    font-size: 9px !important;
    border: none !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const FooterLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  border: none;

  @media print {
    display: flex !important;
    align-items: center !important;
    border: none !important;
  }
`
